

import moment from 'moment';
import React, { Component, useContext } from "react";
import { Button, Panel, Tab, Table, Tabs } from "react-bootstrap";
import Moment from "react-moment";
import Alert from 'react-s-alert';
import AuthContext from '../auth-context';
import Field from '../Shared/Field';
import TrialCoachingSessionsService from '../utils/TrialCoachingSessionsService';
import ZoomRecordsService from "../utils/ZoomRecordsService";
import UsersService from '../utils/UsersService';
import { timezones } from "../utils/variables";
import Flags from './Flags';

const AssignedTo = ({ deal, showAssignModal, coachName }) => {
  const authStore = useContext(AuthContext)

  if (deal.tcs_assigned_to) {
    if (authStore.hasRole('coach_restricted')) {
      return <span>{coachName(deal.tcs_assigned_to)}</span>
    } else {
      return <span className='btn-link' onClick={() => showAssignModal(deal)}>{coachName(deal.tcs_assigned_to)}</span>
    }
  } else {
    return <Button bsStyle='info' bsSize='xs' onClick={() => showAssignModal(deal)}>Assign</Button>
  }
}

class TCSPanel extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.fetchCoaches()
  }

  handleAssignedChange(dealId, event) {
    this.setState({ actionInProgress: true })
    TrialCoachingSessionsService.takeAction('assign', dealId, { email: event.target.value }).then((deal) => {
      this.setState({ deal: deal, actionInProgress: false });
      Alert.success(`Assigned to ${deal.tcs_assigned_to || 'nobody'}`)
    })
  }

  fetchCoaches() {
    UsersService.allUsers().then(data => {
      this.setState({ coaches: data.sort((a, b) => (a.name > b.name) ? 1 : -1) })
    })
  }


  TCSAssigned = () => {
    this.setState({ showModalAssignTCS: false, modalAssignDeal: undefined }, this.reloadDeal)
  }


  coachName = (email) => {
    if (!this.state.coaches) return email
    const coach = this.state.coaches.find((c) => c.email === email)
    return coach ? coach.name || email : email
  }

  handleCopyTranscript = (zoomRecordId) => {
    this.setState({ actionInProgress: true });

    ZoomRecordsService.copyTranscript(zoomRecordId)
      .then((response) => {
        return navigator.clipboard.writeText(response.transcript).then(() => {
          this.setState({ actionInProgress: false });
          Alert.success("Transcript copied successfully.");
        });
      })
      .catch((error) => {
        console.error("Error copying transcript:", error);
        this.setState({ actionInProgress: false });
        Alert.error("Failed to copy transcript. Please try again.");
      });
  };

  render() {
    const { deal } = this.props
    const region = deal.lm_contact.region || 'VIC'
    const tcs_at_user = deal.tcs_at ? moment(deal.tcs_at).tz(timezones[region]).format("dddd MMM Do YYYY h:mm a") + ' in ' + region : 'n/a'
    const tcs_at = deal.tcs_at
      ? moment(deal.tcs_at).format("dddd MMM Do YYYY h:mm a") +
        ` in ${Intl.DateTimeFormat().resolvedOptions().timeZone}`
      : "n/a";

    let zoomMeetingId;
    let zoomMeetingPassword = deal.id
    if (deal.integrations.zoom_tcs_meeting && deal.integrations.zoom_tcs_meeting.join_url) {
      let stripStart = new RegExp('.*/+');
      let stripEnd = new RegExp('\\?+.*');
      zoomMeetingId = deal.integrations.zoom_tcs_meeting.join_url.replace(stripStart, '').replace(stripEnd, '')
    }


    return (
      <Panel bsStyle="success" className='compact-panel'>
        <Panel.Heading>
          <Panel.Title componentClass="h3">
            Trial Coaching Session
        </Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          {deal.tcs_at ?
            <React.Fragment>
              <Flags deal={deal} />

              <Tabs id='deal_tabs' className='compact-tabs'>
                <Tab eventKey={1} title="Overview">
                  <Field label='Your Time' value={tcs_at} />
                  <Field label='User Time' value={tcs_at_user} />
                  <div className="row hover-row" style={{ fontSize: 14, marginTop: 10 }}>
                    <div className="col-sm-5" style={{ fontWeight: 'bold' }}>Assigned To</div>
                    <div className="col-sm-7">
                      {this.state.coaches && <AssignedTo deal={deal} showAssignModal={this.props.assignTCS} coachName={this.coachName} />}
                    </div>
                  </div>

                  <div style={{ marginTop: 10 }}><Field label='Parents in House' value={deal.tcs_parents_in_household} /></div>
                  <div style={{ marginTop: 10 }}><Field label='Parents Attending' value={deal.tcs_parents_attending_tcs} /></div>
                  <div style={{ marginTop: 10 }}><Field label='Device with camera' value={deal.tcs_tech_device} /></div>
                  <div style={{ marginTop: 10 }}><Field label='Student Year Level' value={deal.student_year_level} /></div>

                </Tab>
                <Tab eventKey={2} title="Zoom">
                  {!deal.integrations.zoom_tcs_meeting || (Object.keys(deal.integrations.zoom_tcs_meeting).length === 0 && deal.integrations.zoom_tcs_meeting.constructor === Object)
                    ? <div>No Zoom meeting is booked</div>
                    : <React.Fragment>
                      <Field label='Topic' value={deal.integrations.zoom_tcs_meeting.topic} />
                      <Field label='Start URL' value={<a href={deal.integrations.zoom_tcs_meeting.start_url} target="zoom">Start</a>} />
                      <Field label='Join URL' value={<a href={deal.integrations.zoom_tcs_meeting.join_url} target="zoom">Join</a>} />
                      <Field label='Meeting ID' value={zoomMeetingId} />
                      <Field label='Meeting Password' value={zoomMeetingPassword} />
                      <Field label='Booked at' value={<Moment format="dddd MMM Do YYYY h:mm a">{deal.integrations.zoom_tcs_meeting.created_at}</Moment>} />

                      <h5>Recordings</h5>
                      {deal.zoom_records && deal.zoom_records.length > 0
                        ? (<Table bordered condensed hover style={{ fontSize: 13 }}>
                          <thead className='dark'>
                            <tr>
                              <th style={{ width: 10 }}>ID</th>
                              <th>Topic</th>
                              <th>Type</th>
                              <th>Duration</th>
                              <th>Link</th>
                            </tr>
                          </thead>
                          {deal.zoom_records.map((zoom_record, index) => (
                            <tr key={index}>
                              <td data-label="ID">#{zoom_record.id}</td>
                              <td data-label="Topic">
                                {zoom_record.topic}
                              </td>
                              <td data-label="Type">
                                {zoom_record.recording_type}
                              </td>
                              <td data-label="Duration">
                                {zoom_record.duration}
                              </td>
                              <td data-label="Link">
                                <a
                                  href={zoom_record.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Download
                                </a>
                                {zoom_record.file_type === "VTT" && (
                                  <button
                                    onClick={() =>
                                      this.handleCopyTranscript(
                                        zoom_record.id
                                      )
                                    }
                                    style={{
                                      border: "none",
                                      background: "none",
                                      color: "blue",
                                      cursor: "pointer",
                                      marginLeft: 8,
                                      textDecoration: "underline",
                                    }}
                                  >
                                    Copy
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </Table>)
                        : <div style={{ margin: 10 }}>No recordings in dashboard</div>}

                    </React.Fragment>
                  }
                </Tab>
                <Tab eventKey={3} title="Notes">
                  <Field label='Booking Notes' value={deal.tcs_notes} blockDisplay={true} style={{ marginBottom: 20 }} />
                  {deal.not_presented_reason && deal.not_presented_reason.length > 0 && <Field label='Reason Not Presented' value={deal.notes_not_presented} blockDisplay={true} />}
                  <div style={{ marginTop: 10 }}><Field label='Primary Objective' value={deal.tcs_objective} blockDisplay={true} /></div>
                  <Field label='Objective Notes' value={deal.tcs_objective_notes} blockDisplay={true} />
                </Tab>
              </Tabs>

            </React.Fragment>
            :
            <div>Not booked yet</div>
          }

        </Panel.Body>
      </Panel>
    )
  }
}

export default TCSPanel